<div class="px-4 py-4 bg-white ">
  <full-calendar class="calendar-style  p-0 " [options]="calendarOptions"
    (eventClick)="onEventClick($event)"></full-calendar>

</div>
<mat-menu #menu="matMenu" [overlapTrigger]="false" class="custom-menu" xPosition="before">
  <div class="event-container">
    <div class="d-flex justify-content-end gap-x-2 ">
      <mat-icon class=" cursor-pointer ">close</mat-icon>
    </div>
    <div (click)="$event.stopPropagation()">
      <!-- Event Title -->
      <div class="menu-header">
        <h3>{{ selectedEvent?.title }}</h3>
        <p>{{ selectedEvent?.startDate | date: 'fullDate' }}, {{ selectedEvent?.startDate | date: 'shortTime' }}</p>
      </div>

      <!-- Location -->
      <button mat-menu-item>
        <mat-icon>place_outlined</mat-icon>
        <span>{{selectedEvent?.googleConference}}</span>
      </button>


      <button mat-menu-item class="guest-list mt-10">
        <mat-icon>group</mat-icon>
        <span class="guest-count">{{selectedEvent?.attendees?.length}} guests</span>
        <ng-container *ngFor="let user of selectedEvent?.attendees">
          <button mat-menu-item>
            <mat-icon>account_circle</mat-icon>
            <span>{{user?.name}}</span>
          </button>
        </ng-container>
      </button>
      <!-- Guests -->
      

      <!-- Organizer and Attendees -->
      <div class="menu-subsection">
        <div class="attendee" *ngFor="let guest of selectedEvent?.guests">
          <mat-icon>person</mat-icon>
          <span>{{ guest }}</span>
        </div>
      </div>
      <div class="w-100 mail-content py-4" [innerHTML]="selectedEvent?.description"></div>
      <mat-divider></mat-divider>
      <!-- Meeting Link -->
      <button mat-menu-item class="py-4">
        <mat-icon>link</mat-icon>
        <a [href]="selectedEvent?.meetingLink" target="_blank"><span>Join Meeting</span></a>
      </button>
    </div>
  </div>
</mat-menu>


<button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
  style="position: absolute; visibility: hidden; width: 0; height: 0; border: 0;"></button>